import { FC, ReactNode } from 'react';

import styles from './pageLayout.module.scss';

interface PageLayoutProps {
  navigation?: ReactNode;
  header?: ReactNode;
  children?: ReactNode;
  collapsed: boolean;
}

export const PageLayout: FC<PageLayoutProps> = ({ navigation, header, children, collapsed }) => {
  return (
    <div className={styles.PageLayout}>
      {navigation}
      <div className={collapsed ? styles.navCollapsed : styles.navClosed}>
        {header}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};
